const upsertThreadOptimistic = ({ thread, sidebarOrganizationCommit = null, sidebarOrganizationCommittedAt = null } = {}) => {
  return {
    type: 'pieveUpsertThreadOptimistic',
    payload: {
      thread,
      sidebarOrganizationCommit,
      sidebarOrganizationCommittedAt
    }
  };
};

export default upsertThreadOptimistic;
